import { theme } from 'Assets/Styles/theme'
import classNames from 'classnames'
import ArrowRight from 'Components/Icons/ArrowRight'
import React from 'react'
import injectStyles from 'react-jss'
import { Motion, spring } from 'react-motion'
import { isSmallScreen } from 'Utils/Misc'
import { history } from '../../../Config/history'

const isChatScreen = () =>
  history.location.pathname.includes('/dashboard/chat') ? true : false
const isMobile = isSmallScreen()
const closedX = 68
const openX = 226

const styles = {
  container: {
    position: isMobile ? 'absolute' : 'sticky',
    top: 0,
    maxWidth: 226,
    width: '100%',
    height: '100vh',
    minHeight: 480,
    background: theme.colors.secondary,
    zIndex: theme.zIndexes.sidebar.sidebarWrapper,
    display: 'flex',
    justifyContent: 'flex-end',
    transition: 'max-width .35s ease-in-out',
    '&:>a:last-child': {
      position: 'absolute',
      bottom: 75,
    },
  },
  containerChat: {
    height: 'calc(100vh - 70px)',
  },
  innerContainer: {
    width: 226,
  },
  contentWrapper: {
    width: '100%',
    position: 'relative',
    minHeight: '100%',
    padding: '20px 0px 0 0',
    boxSizing: 'border-box',
    background: theme.colors.alabaster,
    transition: 'max-width .35s ease-in-out',
  },
  contentWrapperChat: {
    minHeight: 'unset',
    padding: '0',
    height: 'calc(100vh - 70px)',
  },
  contentWrapperExpanded: {
    maxWidth: `calc(100% - ${openX}px)`,
  },
  contentWrapperShrunk: {
    maxWidth: `calc(100% - ${closedX}px)`,
  },
  arrowContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
  },
  arrow: {
    position: 'absolute',
    top: '50%',
    right: 0,
    marginTop: -(12 + 5),
    opacity: 0.5,
    zIndex: 10,
    paddingTop: 10,
    paddingBottom: 0,
    width: 24,
    height: 44,
    cursor: 'pointer',
  },
}

const SidebarWrapperComponent = ({
  classes,
  children,
  content,
  onToggle,
  open,
}) => (
  <div>
    <div style={{ display: 'flex' }}>
      <Motion
        defaultStyle={{ factor: open ? 0 : 1 }}
        style={{ factor: spring(open ? 0 : 1) }}
      >
        {({ factor }) => (
          <div
            className={classNames({
              [classes.container]: true,
              [classes.containerChat]: isChatScreen(),
            })}
            style={{
              transition: 'max-width .35s ease-in-out',
              maxWidth: open ? openX : closedX,
            }}
          >
            <div className={classes.innerContainer}>
              <div className={classes.arrowContainer} onMouseUp={onToggle}>
                <ArrowRight
                  className={classes.arrow}
                  style={{
                    transform: `rotateY(${180 * (1 - factor)}deg)`,
                  }}
                />
              </div>
              <div>{children}</div>
            </div>
          </div>
        )}
      </Motion>
      <div
        className={classNames({
          [classes.contentWrapper]: true,
          [classes.contentWrapperExpanded]: open,
          [classes.contentWrapperShrunk]: !open,
          [classes.contentWrapperChat]: isChatScreen(),
        })}
      >
        {content}
      </div>
    </div>
  </div>
)

export const SidebarWrapper = injectStyles(styles)(SidebarWrapperComponent)



// WEBPACK FOOTER //
// ./src/Components/Sidebar/SidebarWrapper/index.js